exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-3a4387ea] {\n  height: 395px;\n}", ""]);

// exports
